import { ApolloQueryResult } from '@apollo/client'
import { useCidadaosCadastroImovelQuery } from 'graphql/hooks.generated'
import { CidadaosCadastroImovelQuery, CidadaoTerritorio } from 'graphql/types.generated'

interface UseCidadaosImovelResult {
  cidadaos: ReadonlyArray<CidadaoTerritorio>
  loading: boolean
  refetch: () => Promise<ApolloQueryResult<CidadaosCadastroImovelQuery>>
}

export function useCidadaosImovel(cidadaosIds: ID[]): UseCidadaosImovelResult {
  const {
    data: { cidadaosTerritorio },
    previousData,
    loading,
    refetch,
  } = useCidadaosCadastroImovelQuery({
    variables: {
      input: cidadaosIds,
    },
    fetchPolicy: 'cache-and-network',
    skip: !cidadaosIds || cidadaosIds?.isEmpty(),
  })

  const cidadaos = cidadaosTerritorio ?? previousData?.cidadaosTerritorio

  return { cidadaos, loading: loading && !cidadaos, refetch }
}
